export enum PriceListType {
    Gross = 'gross',
    Net = 'net'
}
